import {AOperationWithEquipment} from "./AOperationWithEquipment";
import {AElement} from "../elements/AElement";
import GPSCoordinates from "../GPSCoordinates";
import {EOperationType} from "../utils/EOperationType";
import {Icon} from "../Icon";
import MarkerIconService from "../../services/map/MarkerIconService";
import {CSS_CLASS_NAME_GRAY_MARKER, CSS_CLASS_NAME_ORANGE_MARKER} from "../../services/UtilsService";
import RemapService from "../../services/RemapService";

export class ReplaceElement extends AOperationWithEquipment {

    private _newElement: AElement | undefined;

    private _oldElement: AElement | undefined;

    constructor(id: string, idUser: string, date: Date, equipmentId?: string, newElement?: AElement, oldElement?: AElement, geolocation?: GPSCoordinates, isSynchro?: boolean, commentary?: string) {
        const icon = new Icon(
            MarkerIconService.OPERATION_REPLACE_ELEMENT_ICON_PATH,
            MarkerIconService.generateIcon(MarkerIconService.OPERATION_REPLACE_ELEMENT_ICON_PATH, isSynchro ? CSS_CLASS_NAME_ORANGE_MARKER : CSS_CLASS_NAME_GRAY_MARKER)
        );
        super(id, idUser, EOperationType.ReplacementElement, date, icon, geolocation, isSynchro, commentary, equipmentId);
        this._newElement = newElement;
        this._oldElement = oldElement;
    }

    get newElement(): AElement | undefined {
        return this._newElement;
    }

    set newElement(value: AElement | undefined) {
        this._newElement = value;
    }

    get oldElement(): AElement | undefined {
        return this._oldElement;
    }

    set oldElement(value: AElement | undefined) {
        this._oldElement = value;
    }

    public static remapObjectToOperation(object: any): ReplaceElement | null {
        let operation: ReplaceElement | null = null;
        if(
            object._id &&
            object._idUser &&
            object._date &&
            object._geolocation &&
            object._newElement &&
            object._oldElement &&
            object._equipmentId
        ) {
            const location = GPSCoordinates.remapObjectToGPSCoordinate(object._geolocation);
            const newElement = RemapService.remapObjectToElement(object._newElement);
            const oldElement = RemapService.remapObjectToElement(object._oldElement);
            if(location && newElement && oldElement) {
                operation = new ReplaceElement(
                    object._id,
                    object._idUser,
                    object._date,
                    object._equipmentId,
                    newElement,
                    oldElement,
                    location,
                    object._isSynchro,
                    object._commentary
                );
            }
        }
        return operation;
    }

    isCorrect(): boolean {
        return (
            super.isCorrect() &&
            this.oldElement !== undefined &&
            this.oldElement.isCorrect() &&
            this.newElement !== undefined &&
            this.newElement.isCorrect()
        );
    }
}
